import styled from 'styled-components';
import { baseTheme } from '../../../../global/styles/theme';

export const RecipeInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;

  .products-err {
    padding: 10px;
    color: ${baseTheme.colors.error};
  }

  .products-empty {
    padding: 10px;
    color: ${baseTheme.colors.mainLightBlue};
  }

  .medicines-list-block {
    width: 100%;
    height: 100%;
    border: 1px solid ${baseTheme.colors.mainLightBlue};
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .recipe-info {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-start;
      align-content: flex-start;
      .recipe-info-item {
        width: 48%;
        height: fit-content;
        margin: 0;
      }
    }
  }
`;

export const ApplyProductsButton = styled.button`
  cursor: pointer;
  height: 40px;
  width: 48%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: ${baseTheme.colors.mainLightBlue};
  border-radius: 8px;
  border: none;
  font-size: 14px;
  padding: '0px 10px';
  color: ${baseTheme.colors.white};
`;
